export const useColorPalette = () => {
    const colorPalette = (colorPalette?: string) => {
        switch (colorPalette) {
            case 'color-subtle':
                return 'brand'
            case 'color-invert':
                return 'brand-invert'
            default:
                return colorPalette
        }
    }
    return { colorPalette }
}
